import actions from "rdx/actions";

export default ({ error, message }) => {
  const newErr = { error, errorUID: error.error_uid };
  if (message) newErr.message = message;
  return [actions.newErrorEvent(newErr)];
};
